export const cortaString = (texto, longitud) => {
  if (texto.length > longitud) {
    return texto.slice(0, longitud) + "...";
  }

  return texto;
};
